import Restore from '@mui/icons-material/Restore';
import { makeObservable, observable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroRetornoAdiamento extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Retorno de adiamento';
    }

    getIconeFiltroRapido() {
        return <Restore />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return registro.retornoAdiamento;
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
